'use client'
import './globals.css'
import { Provider as ReduxProvider } from 'react-redux'
import { store } from '@/store'
import SessionTimeout from '@/components/SessionTimeout'

export default function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <body>
        <ReduxProvider store={store}>
          <SessionTimeout />
          {children}
        </ReduxProvider>
      </body>
    </html>
  )
}
